import { LayerComponentBase } from "@/stellar-globe-components";
import { EquatorialCoord } from "@hscmap/angle";
import { PointEvent, PointEventLayer } from '@hscmap/stellar-globe';
import { Component, Prop } from "vue-property-decorator";

export interface ICoordPair {
  c0: EquatorialCoord
  c1: EquatorialCoord
}

class TwoPointPickerLayer extends PointEventLayer {
  constructor(readonly picker: TwoPointsPicker, readonly normalize: boolean) {
    super()
  }

  hit() {
    return true
  }

  get el() {
    return this.globe.canvas.domElement
  }

  c0?: EquatorialCoord
  c1?: EquatorialCoord

  dragStart(e: PointEvent) {
    this.c0 = e.coord
    this.c1 = undefined
    this.picker.change(null)
    e.stopPropagation()
  }

  drag(e: PointEvent) {
    this.c1 = e.coord
    this.picker.change(this.normalize ? this.normalizedCoordPair() : { c0: this.c0!, c1: this.c1! })
  }

  private normalizedCoordPair(): ICoordPair {
    const c0 = this.c0!
    const c1 = this.c1!
    const d0 = Math.min(c0.d.rad, c1.d.rad)
    const d1 = Math.max(c0.d.rad, c1.d.rad)
    let a0 = Math.min(c0.a.rad, c1.a.rad)
    let a1 = Math.max(c0.a.rad, c1.a.rad)
    if (Math.abs(c0.a.rad - c1.a.rad) > Math.PI) {
      [a0, a1] = [a1, a0]
      a1 += 2 * Math.PI
    }
    return { c0: EquatorialCoord.fromRad(a0, d0), c1: EquatorialCoord.fromRad(a1, d1) }
  }
}

@Component
export class TwoPointsPicker extends LayerComponentBase<TwoPointPickerLayer> {
  @Prop({ required: true })
  value!: ICoordPair | null

  @Prop({ default: false })
  normalize!: boolean

  newLayer() {
    return new TwoPointPickerLayer(this, this.normalize)
  }

  change(coordPair: ICoordPair | null) {
    this.$emit('input', coordPair)
  }
}
